import React, { Component } from 'react';

class ImageLoader extends Component {
  state = {
    loaded: false,
  };

  render() {
    const className = this.state.loaded ? 'img-loaded' : 'img-loading';

    return (
      <img
        {...this.props}
        className={className}
        onLoad={() =>
          this.setState({
            loaded: true,
          })
        }
      />
    );
  }
}

export default ImageLoader;
